// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tableau{min-height:600px;position:relative}.tableau__card-header{flex:1 1 auto}.tableau--error{align-items:center;display:flex;justify-content:center}.tableau__error-page{align-items:center;display:flex;flex-direction:column;justify-content:center}.tableau__iframe{position:absolute;width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
